module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-wrapper ",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope "
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Análise   \n            "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>199 - Comunicado Interno</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(199)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 199\n              ")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>219 - Adiantamentos (PDF)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(219)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 219\n              ")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>525 - Extrato Analítico de Projeto (PDF)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(525, 'S')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 525A\n              ")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>525 - Extrato Sintético de Projeto (PDF)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(525, 'N')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 525S\n              ")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>248 - Monitoramento Administrativo</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(248)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 248\n              ")]), _vm._v(" "), (_vm.usuarioLogado.userType !== 'ENTIDADE' && _vm.etapa !== 'Solicitação') ? _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "title": '<h5>Faz o download de todos os arquivos da solicitação (zip)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onDownloadZIP()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(" Baixar arquivos")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "font-size": "30px"
    }
  })]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Validação',
        href: '#'
      }, {
        text: 'Adiantamento',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.concluir($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [(!_vm._.isEmpty(_vm.chamado) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "medium"
    }
  }, [_vm._v("* Atenção: O processo que será analisado possui chamado vinculado - "), _c('b', _vm._l((_vm.chamado), function(c, index) {
    return _c('span', [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: 'cadastro-chamado-edita',
          params: {
            id: c.id
          }
        }
      }
    }, [_vm._v(" " + _vm._s(c.id) + " "), (_vm.chamado.length > 1 && index === 0) ? _c('span', [_vm._v(",  ")]) : _vm._e()])], 1)
  }), 0), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), ((_vm.historicoTarefasTela.length > 0 && _vm.historicoTarefasTela[1].observacao != null && _vm.historicoTarefasTela[1].observacao !== '')) ? _c('div', {
    staticClass: "alert alert-dismissible alert-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h5', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.historicoTarefasTela[1].observacao)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Validação de Adiantamento - "), _c('i', [_c('font', {
    attrs: {
      "color": "black",
      "size": "3"
    }
  }, [_vm._v("ID: " + _vm._s(_vm.form.id) + " - Projeto: ")]), _c('font', {
    attrs: {
      "color": "black",
      "size": "3"
    }
  }, [_vm._v(_vm._s(_vm.proposta.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.proposta.ds_nome))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "ng-if": "$ctrl.approvalState != 'DEFAULT'"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmSearch",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group required"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('dl', {
    staticClass: "proposal-definition-list"
  }, [_c('dt', [_vm._v("Objetivo Geral: ")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.proposta.ds_objetivo_geral))]), _vm._v(" "), _c('dt', [_vm._v("Situação:")]), _vm._v(" "), _vm._m(1)])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('fieldset', [(_vm.form.documentos_liberacao.length) ? _c('cronograma-solicitacao-adiantamento-validacao', {
    attrs: {
      "props-fase": _vm.form.tarefas[0].nome,
      "props-enable": _vm.form.tarefas[0].nome === 'Análise' || _vm.form.tarefas[0].nome === 'Revisão',
      "props-itens": _vm.form.documentos_liberacao[0].itens_liberados
    },
    on: {
      "parcelaAdicionada": function($event) {
        _vm.form.documentos_liberacao[0].itens_liberados = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.form.documentos_liberacao[0].dados_bancarios)) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('banco')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Banco:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('lista-bancos', {
    attrs: {
      "propsBanco": _vm.form.documentos_liberacao[0].dados_bancarios.banco,
      "banco": _vm.form.documentos_liberacao[0].dados_bancarios.banco,
      "disabled": _vm.usuarioLogado.userType !== 'FUNDACAO'
    },
    on: {
      "update:banco": function($event) {
        return _vm.$set(_vm.form.documentos_liberacao[0].dados_bancarios, "banco", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('agência')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Agência:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "title": '<h5> ' + (_vm._.has(_vm.form.documentos_liberacao[0].dados_bancarios.banco, 'digitoAgencia') && !_vm.form.documentos_liberacao[0].dados_bancarios.banco.digitoAgencia ? 'Informe a agência com 4 número sem dígito verificador. Exemplo: <span class=\'realce\'>1234</span>' : 'Informe a agência com 4 número e o dígito verificador. Exemplo: <span class=\'realce\'>1234-5</span>') + ' </h5>'
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "agência",
      "disabled": this.form.tarefas[0].nome !== 'Análise',
      "type": "text",
      "mask": _vm._.has(_vm.form.documentos_liberacao[0].dados_bancarios.banco, 'digitoAgencia') && !_vm.form.documentos_liberacao[0].dados_bancarios.banco.digitoAgencia ? '####' : '####-X',
      "masked": ""
    },
    model: {
      value: (_vm.form.documentos_liberacao[0].dados_bancarios.agencia),
      callback: function($$v) {
        _vm.$set(_vm.form.documentos_liberacao[0].dados_bancarios, "agencia", $$v)
      },
      expression: "form.documentos_liberacao[0].dados_bancarios.agencia"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('agência')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('conta corrente')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Conta " + _vm._s(_vm.form.documentos_liberacao[0].dados_bancarios.tipo === 1 ? 'Corrente' : (_vm.form.documentos_liberacao[0].dados_bancarios.tipo === 2 ? 'Poupança' : '')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3'),
      expression: "'required|min:3'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "conta corrente",
      "type": "text",
      "mask": ['#-X', '##-X', '###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X', '##########-X', '###########-X'],
      "masked": "",
      "disabled": this.form.tarefas[0].nome !== 'Análise'
    },
    model: {
      value: (_vm.form.documentos_liberacao[0].dados_bancarios.conta),
      callback: function($$v) {
        _vm.$set(_vm.form.documentos_liberacao[0].dados_bancarios, "conta", $$v)
      },
      expression: "form.documentos_liberacao[0].dados_bancarios.conta"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('conta corrente')))]) : _vm._e()])]), _vm._v(" "), _c('tipo-conta', {
    attrs: {
      "propsTipo": _vm.form.documentos_liberacao[0].dados_bancarios.tipo,
      "tipo": _vm.form.documentos_liberacao[0].dados_bancarios.tipo,
      "disabled": this.form.tarefas[0].nome !== 'Análise'
    },
    on: {
      "update:tipo": function($event) {
        return _vm.$set(_vm.form.documentos_liberacao[0].dados_bancarios, "tipo", $event)
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div'), _vm._v(" "), (_vm.form.documentos_liberacao.length) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(3), _vm._v(" "), _c('upload-documentos-php', {
    attrs: {
      "propDocumentos": _vm.form.documentos_liberacao[0].documentos_adiantamento,
      "documentTypes": '',
      "disable": _vm.form.tarefas[0].nome === 'Autorização'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.documentos_liberacao.length) ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(4), _vm._v(" "), _c('upload-documentos-php', {
    attrs: {
      "propDocumentos": _vm.form.documentos_liberacao[0].documentos_anexos_adiantamento,
      "documentTypes": '',
      "disable": _vm.form.tarefas[0].nome === 'Autorização'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(5), _vm._v(" "), (_vm.historicoBack && !_vm._.isNull(_vm.historicoBack) && !_vm._.isEmpty(_vm.historicoBack)) ? _c('historico-solicitacao-pagamento', {
    key: _vm.historicoBack.length,
    attrs: {
      "propsValidacao": _vm.form,
      "propsHistorico": _vm.historicoBack
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.historicoBack) ? _c('div', {
    staticClass: "text-left box-header"
  }, [(_vm.esconderHistorico === false) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderHistorico = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Mostrar histórico antigo")]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderHistorico = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ocultar histórico antigo")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true && !_vm.historicoBack) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(6), _vm._v(" "), (!_vm._.isUndefined(_vm.historicoAnt)) ? _c('historico-solicitacao-pagamento', {
    attrs: {
      "propsValidacao": _vm.form,
      "propsHistorico": _vm.historicoAnt
    }
  }) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm.form.tarefas[0].nome === 'Análise Financeira') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group full",
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Opções para este documento:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
    staticClass: " new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bypass),
      expression: "bypass"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "checkbox",
      "false-value": '',
      "true-value": 'BYPASS',
      "name": "acao"
    },
    domProps: {
      "checked": Array.isArray(_vm.bypass) ? _vm._i(_vm.bypass, null) > -1 : _vm._q(_vm.bypass, 'BYPASS')
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.bypass,
          $$el = $event.target,
          $$c = $$el.checked ? ('BYPASS') : ('');
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.bypass = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.bypass = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.bypass = $$c
        }
      }, function($event) {
        return _vm.atualizaOpcoes('BYPASS')
      }]
    }
  }), _vm._v("Não integrar com Sapiens\n                              "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group required-field full",
    class: {
      'has-error': _vm.errors.first('resultadoAprovacao')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    ref: "resultadoAprovacao",
    staticClass: "control-label",
    attrs: {
      "for": "resultadoAprovacao"
    }
  }, [_vm._v("Aprovar solicitação?")]), _vm._v(" "), _c('div', [(_vm.form.tarefas[0].nome === 'Análise' || _vm.form.tarefas[0].nome === 'ANALISE') ? _c('label', {
    staticClass: "radio-inline new-control new-control-radio ng-binding"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tarefa.proximaEtapa),
      expression: "tarefa.proximaEtapa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched",
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "Autorização"
    },
    domProps: {
      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Autorização")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tarefa, "proximaEtapa", "Autorização")
      }
    }
  }), _vm._v(" Aprovar solicitação de adiantamento\n                                    "), _c('div', {
    staticClass: "new-control-indicator"
  })]) : (_vm.form.tarefas[0].nome === 'Autorização') ? _c('label', {
    staticClass: "radio-inline new-control new-control-radio ng-binding"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tarefa.proximaEtapa),
      expression: "tarefa.proximaEtapa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched",
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "Análise Financeira"
    },
    domProps: {
      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Análise Financeira")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tarefa, "proximaEtapa", "Análise Financeira")
      }
    }
  }), _vm._v(" Aprovar solicitação de adiantamento\n                                    "), _c('div', {
    staticClass: "new-control-indicator"
  })]) : (_vm.form.tarefas[0].nome === 'Análise Financeira') ? _c('label', {
    staticClass: "radio-inline new-control new-control-radio ng-binding"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tarefa.proximaEtapa),
      expression: "tarefa.proximaEtapa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched",
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "Conclusão"
    },
    domProps: {
      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Conclusão")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tarefa, "proximaEtapa", "Conclusão")
      }
    }
  }), _vm._v(" Aprovar solicitação de adiantamento\n                                    "), _c('div', {
    staticClass: "new-control-indicator"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.tarefas[0].nome === 'Análise' || _vm.form.tarefas[0].nome === 'Autorização' || _vm.form.tarefas[0].nome === 'Análise Financeira') ? _c('label', {
    staticClass: "radio-inline new-control new-control-radio ng-scope"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tarefa.proximaEtapa),
      expression: "tarefa.proximaEtapa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "Revisão"
    },
    domProps: {
      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Revisão")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tarefa, "proximaEtapa", "Revisão")
      }
    }
  }), _vm._v(" Encaminhar para revisão da entidade\n                                  "), _c('div', {
    staticClass: "new-control-indicator"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.tarefas[0].nome === 'Autorização' || _vm.form.tarefas[0].nome === 'Análise Financeira' || _vm.form.tarefas[0].nome === 'Revisão') ? _c('label', {
    staticClass: "radio-inline new-control new-control-radio ng-scope"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tarefa.proximaEtapa),
      expression: "tarefa.proximaEtapa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "Análise"
    },
    domProps: {
      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Análise")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tarefa, "proximaEtapa", "Análise")
      }
    }
  }), _vm._v(" Retornar para análise\n                                    "), _c('div', {
    staticClass: "new-control-indicator"
  })]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio ng-scope"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tarefa.proximaEtapa),
      expression: "tarefa.proximaEtapa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "type": "radio",
      "name": "resultadoAprovacao",
      "value": "Cancelar"
    },
    domProps: {
      "checked": _vm._q(_vm.tarefa.proximaEtapa, "Cancelar")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.tarefa, "proximaEtapa", "Cancelar")
      }
    }
  }), _vm._v(" Cancelar Solicitação\n                                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])])]), _vm._v(" "), (_vm.tarefa.proximaEtapa === 'Revisão') ? _c('div', {
    staticClass: "form-group required-field full",
    class: {
      'has-error': _vm.errors.first('justificativa')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "motivo de devolucao"
    }
  }, [_vm._v("Motivo de devolução:")]), _vm._v(" "), _c('div', [_c('div', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.motivosDevolucao,
      "multiple": false,
      "close-on-select": true,
      "placeholder": "Selecione um motivo de Devolução para a entidade",
      "custom-label": _vm.motivoDevolucaoDescricao,
      "track-by": "codigo",
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "motivo de devolucao",
      "data-vv-as": "motivo de devolucao",
      "option-height": 30,
      "disabled": _vm.ehVisualizacao
    },
    model: {
      value: (_vm.motivoDevolucao),
      callback: function($$v) {
        _vm.motivoDevolucao = $$v
      },
      expression: "motivoDevolucao"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('motivo de devolucao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo de devolucao')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.tarefa.proximaEtapa) ? _c('div', {
    staticClass: "form-group full",
    class: [{
      'has-error': _vm.errors.first('observacao')
    }, {
      'required-field': _vm.tarefa.proximaEtapa !== 'Autorização'
    }],
    staticStyle: {
      "margin-right": "0px",
      "margin-left": "0px"
    }
  }, [(_vm.tarefa.proximaEtapa === 'Revisão') ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "observacao"
    }
  }, [_vm._v("Motivo para revisão:")]) : _vm._e(), _vm._v(" "), (_vm.tarefa.proximaEtapa === 'Autorização') ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "observacao"
    }
  }, [_vm._v("Observação:")]) : _vm._e(), _vm._v(" "), (_vm.tarefa.proximaEtapa === 'Cancelar') ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "observacao"
    }
  }, [_vm._v("Motivo para cancelamento:")]) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tarefa.observacao),
      expression: "tarefa.observacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required_if:resultadoAprovacao,Revisão'),
      expression: "'required_if:resultadoAprovacao,Revisão'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required",
    attrs: {
      "name": "observacao",
      "id": "observacao",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.tarefa.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tarefa, "observacao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('observacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('observacao')))]) : _vm._e()]) : _vm._e()])])])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "type": "submit",
      "disabled": _vm.restricao || _vm.tarefa.proximaEtapa === '' || _vm.form.busy
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa fa-info"
  }), _vm._v("   Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dd', [_c('span', [_vm._v("Em Execução")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dados Bancários")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos do Adiantamento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos Anexos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico de solicitação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico Antigo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Aprovação da solicitação de adiantamento")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c843ee9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/solicitacoes/adiantamento/validacaoAdiantamentoAnalise.vue
// module id = 1872
// module chunks = 1